import { faClockRotateLeft } from "@fortawesome/free-solid-svg-icons/faClockRotateLeft";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons/faTriangleExclamation";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { AtiraIcon } from "../../../../../components/AtiraIcon";
import { Flex } from "../../../../../components/Flex";
import { Spinner } from "../../../../../components/Spinner";
import { Text } from "../../../../../components/Text";
import { Spacing } from "../../../../../theme/Spacing";

const Row = styled(Flex)`
  align-items: center;
  gap: ${Spacing.s};
  opacity: 0.75;
  max-width: 17rem;
`;

const Label = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

type Props = {
  label: string;
  expired?: boolean;
  pending?: boolean;
};

export const WAMediaUnavailable: React.FC<Props> = ({
  label,
  expired,
  pending,
}) => {
  const { t } = useTranslation();

  if (pending) {
    return (
      <Row>
        <Spinner />
        <Label fontSize="s">{label}</Label>
      </Row>
    );
  }

  return (
    <Row>
      <AtiraIcon
        icon={expired ? faClockRotateLeft : faTriangleExclamation}
        size="sm"
      />
      <Flex flexDirection="column" minWidth="0">
        <Label fontSize="s">{label}</Label>
        {expired ? (
          <Text fontSize="xs" style={{ opacity: 0.8 }}>
            {t("integration.whatsapp.meta.media.expired")}
          </Text>
        ) : null}
      </Flex>
    </Row>
  );
};
